import { computed, ComputedRef, MaybeRef, unref } from 'vue'

export interface CurrencyConfig {
  currencySymbol: string
  thousandsSeparator: string
  decimalSeparator: string
  showFractions: boolean
}

export interface useCurrencyReturn {
  config: ComputedRef<CurrencyConfig>
  configNoFractions: ComputedRef<CurrencyConfig>
}

export default function useCurrency(
  currency: MaybeRef<string> | string | undefined = undefined,
): useCurrencyReturn {
  const currencySymbol = computed(() => {
    const c = unref(currency)
    if (c !== undefined) {
      return currencySymbolMap[c] ?? c
    }
    return currencySymbolMap[currentAccount.currency] ?? currentAccount.currency
  })

  const { thousandsSeparator, decimalSeparator } = currentLocale

  const config = computed(() => ({
    currencySymbol: currencySymbol.value,
    thousandsSeparator,
    decimalSeparator,
    showFractions: true,
  }))

  const configNoFractions = computed(() => ({ ...config.value, showFractions: false }))

  return {
    config,
    configNoFractions,
  }
}
